import merge from 'lodash/merge';

class BreakPoints {
	constructor(options) {
		const defaults = {
			'resizeThrottle': 50
		};

		this.options = merge(defaults, options || {});

		this.resizeTimeout = null;
		this.breakpointDefault = 'general';

		// Default breakpoints for browsers that don't support pseudo elements or media queries
		this.breakpoints = {
			'general': 'desktop', // desktop || mobile
			'precise': 'large'
		};

		this.oldBreakpoints = {
			'general': null,
			'precise': null
		};

		this.subscribers = [];

		this._initialize();
	}

	_initialize() {
		this._setCurrentBreakpoints();

		// Setup resize listening
		window.addEventListener('resize', () => {
			this.resizeTimeout = setTimeout(() => {
				clearTimeout(this.resizeTimeout);
				this._resized();
			}, this.options.resizeThrottle);
		});
	}

	_setCurrentBreakpoints() {
		let preciseBreakpoint, generalBreakpoint;

		// General breakpoints are defined in <body> pseudoelement :before
		generalBreakpoint = window.getComputedStyle(document.body, ':before').getPropertyValue('content');

		// Precise breakpoints are defined in <body> pseudoelement :after
		preciseBreakpoint = window.getComputedStyle(document.body, ':after').getPropertyValue('content');

		// Parse results
		generalBreakpoint = generalBreakpoint !== 'none' ? generalBreakpoint.replace(/"/g, '').replace(/'/g, '') : '';
		preciseBreakpoint = preciseBreakpoint !== 'none' ? preciseBreakpoint.replace(/"/g, '').replace(/'/g, '') : '';

		// Set new breakpoints
		if (generalBreakpoint !== this.oldBreakpoints.general) {
			this.oldBreakpoints.general = this.breakpoints.general;
			this.breakpoints.general = generalBreakpoint;
		}

		if (preciseBreakpoint !== this.oldBreakpoints.precise) {
			this.oldBreakpoints.precise = this.breakpoints.precise;
			this.breakpoints.precise = preciseBreakpoint;
		}
	}

	_resized() {
		this._setCurrentBreakpoints();

		for (let key in this.breakpoints) {
			if (Object.prototype.hasOwnProperty.call(this.breakpoints, key)) {
				// if breakpoint has changed notify subscribers
				if (this.oldBreakpoints[key] !== this.breakpoints[key]) {
					this._notifyBreakpointChangeSubscribers(key);
					this.oldBreakpoints[key] = this.breakpoints[key];
				}
			}
		}
	}

	_notifyBreakpointChangeSubscribers(type) {
		var i;

		for (i = this.subscribers.length - 1; i >= 0; i--) {
			if (this.subscribers[i].breakpointType === type) {
				this.subscribers[i].subscriber(this.breakpoints[type], this.oldBreakpoints[type]); // notify with new and old breakpoint
			}
		}
	}

	addChangeSubscriber(subscriber, breakpointType) {
		if (typeof subscriber === 'function') {
			this.subscribers.push({
				subscriber: subscriber,
				breakpointType: breakpointType || 'general' // Default to general breakpoints
			});
		} else {
			throw new Error('Subscriber needs to be a function');
		}
	}

	getBreakpoint(breakpointType) {
		return this.breakpoints[breakpointType || this.breakpointDefault];
	}
}

const breakPoints = new BreakPoints();

export default breakPoints;
export { breakPoints };
